(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ouafy-before-after"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('input', (event) => {
  const range = event.target.closest('[data-oy-ba-range]');
  if (!range) return;

  const wrapper = range.closest('.oy-ba');
  if (!wrapper) return;

  wrapper.style.setProperty('--oy-ba-pos', `${range.value}%`);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ouafy-social-proof"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-oy-proof-prev], [data-oy-proof-next]');
  if (!button) return;

  const track = button.parentElement.querySelector('[data-oy-proof-track]');
  if (!track) return;

  const card = track.querySelector('.oy-proof__card');
  const step = card ? card.offsetWidth + 12 : track.clientWidth * 0.8;
  const direction = button.hasAttribute('data-oy-proof-next') ? 1 : -1;

  track.scrollBy({ left: step * direction, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();
})();
